export default "__VITE_ASSET__BTyDypS5__"